import initialState from './initialState'
import { OverviewActionNames } from './actionNames'
import { xor } from 'lodash'
import { AuthorizationActions } from '../userAccount/actionNames'

export default function(
  store: IOverviewStore = initialState,
  action: any,
): IOverviewStore {
  switch (action.type) {
    case OverviewActionNames.SetSelectedIndex:
      return {
        ...store,
        selectedIndex: action.payload,
        dateFrom: undefined,
        dateTo: undefined,
        differencePeriod: undefined,
      }
    case OverviewActionNames.SetSelectedDates:
      return {
        ...store,
        dateFrom: action.payload.dateFrom,
        dateTo: action.payload.dateTo,
      }
    case OverviewActionNames.SetDifferecePeriod:
      return {
        ...store,
        error: false,
        differencePeriod: action.payload,
      }
    case OverviewActionNames.SetSelectedRooms:
      return {
        ...store,
        selectedRooms: action.payload,
      }
    case OverviewActionNames.ToggleSelectedRoom:
      return {
        ...store,
        selectedRooms: xor(store.selectedRooms, [action.payload]),
      }

    case OverviewActionNames.UpdateStats:
      return {
        ...store,
        error: store.error ? store.error : !isNaN(action.payload.RevPAR),
        stats: action.payload,
      }
    case AuthorizationActions.SignOffTheAccount:
      return { ...initialState }
    default:
      return store
  }
}

export interface IOverviewStore {
  error: boolean
  dateFrom: Date
  dateTo: Date
  selectedIndex: number
  selectedRooms: number[]
  stats: any
  differencePeriod: {
    from: Date
    to: Date
    diffFrom: Date
    diffTo: Date
    type: number
  }
}
